import { render, staticRenderFns } from "./PlayerTeam.vue?vue&type=template&id=11b26fee&scoped=true"
import script from "./PlayerTeam.vue?vue&type=script&lang=js"
export * from "./PlayerTeam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11b26fee",
  null
  
)

export default component.exports